'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.renderDraftAsHtml = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _draftConvert = require('draft-convert');

var _draftJs = require('draft-js');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var renderDraftAsHtml = exports.renderDraftAsHtml = function renderDraftAsHtml(raw) {
    return (0, _draftConvert.convertToHTML)({
        styleToHTML: function styleToHTML(style) {
            switch (style) {
                case 'BOLD':
                    return _react2.default.createElement('strong', null);
                    break;
                case 'ITALIC':
                    return _react2.default.createElement('i', null);
                    break;
            }
        },
        blockToHTML: function blockToHTML(block) {
            if (block.type === 'PARAGRAPH') {
                return _react2.default.createElement('p', null);
            }
        },
        entityToHTML: function entityToHTML(entity, originalText) {
            if (entity.type === 'LINK' || entity.type.toLowerCase().indexOf('link') === 0) {
                return _react2.default.createElement(
                    'a',
                    { href: entity.data.url },
                    originalText
                );
            }
            if (!!entity.data.placeholder) {
                return _react2.default.createElement(
                    'strong',
                    null,
                    entity.data.placeholder
                );
            }
            return originalText;
        }
    })((0, _draftJs.convertFromRaw)(raw));
};

var TextContent = function TextContent(props) {
    if (props.content) {
        return _react2.default.createElement('span', { dangerouslySetInnerHTML: { __html: props.content } });
    }
    return null;
};

exports.default = function (props) {
    var content = props.data.get('content');
    var blockType = props.data.get('blockType');
    if (!content || !blockType) {
        return null;
    }
    var htmlContent = false;
    try {
        htmlContent = renderDraftAsHtml(content.toJS());
    } catch (err) {}
    if (htmlContent) {
        switch (blockType) {
            case 'heading':
                return _react2.default.createElement(
                    'h1',
                    null,
                    _react2.default.createElement(TextContent, { content: htmlContent })
                );
            case 'subtitle':
                return _react2.default.createElement(
                    'h2',
                    null,
                    _react2.default.createElement(TextContent, { content: htmlContent })
                );
            case 'body':
                return _react2.default.createElement(
                    'p',
                    null,
                    _react2.default.createElement(TextContent, { content: htmlContent })
                );
            default:
                return _react2.default.createElement(
                    'p',
                    null,
                    _react2.default.createElement(TextContent, { content: htmlContent })
                );
        }
    }
    return null;
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/wse-quiz-component/lib/blocks/TextBlock.js
// module id = 141
// module chunks = 0